import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ResourceVersionFragmentDoc } from '../../fragment/generated/ResourceVersion';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetContentVersionsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.ResourceVersionFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type GetContentVersionsQuery = { contentVersions: { success: boolean, totalCount: number, edges?: Array<{ node: { id: string, versionNumber: string, note: string, type: Types.ResourceVersionTypeEnum, createdAt: string, createdBy?: { id: string, name?: string | null } | null } }> | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null } };


export const GetContentVersionsDocument = /*#__PURE__*/ gql`
    query getContentVersions($filters: ResourceVersionFilters, $first: Float, $after: String, $sort: [SortType!]) {
  contentVersions(sort: $sort, filters: $filters, first: $first, after: $after) {
    success
    totalCount
    edges {
      node {
        ...ResourceVersion
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${ResourceVersionFragmentDoc}`;

export function useGetContentVersionsQuery(options?: Omit<Urql.UseQueryArgs<GetContentVersionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetContentVersionsQuery, GetContentVersionsQueryVariables>({ query: GetContentVersionsDocument, ...options });
};